module.exports = __webpack_public_path__ + "static/media/dni_front_helper.d355eace.svg";